import { useEffect } from 'react';

import { MAX_RESOURCE_PER_TYPE } from 'src/data/common';
import {
  generateResourceUploadId,
  RESOURCE_CONTENT_TYPE,
  RESOURCE_STATUS,
} from 'src/data/performance';

import { ACTION } from '../const';

export const useSupportPasteEvent = ({
  rootElement,
  disablePaste,
  shouldOpenConfirmPopup,
  index,
  onAction,
}) => {
  useEffect(() => {
    if (!rootElement || disablePaste) {
      return;
    }

    const handler = async (e) => {
      if (!e?.clipboardData?.files?.length) {
        return;
      }

      const pastedFile = e.clipboardData.files[0];
      const resourceType = pastedFile.type.startsWith(RESOURCE_CONTENT_TYPE.image)
        ? RESOURCE_CONTENT_TYPE.image
        : RESOURCE_CONTENT_TYPE.document;

      if (shouldOpenConfirmPopup([resourceType], pastedFile)) {
        onAction(ACTION.displayMessage, {
          message: `You can use a maximum of ${MAX_RESOURCE_PER_TYPE} ${resourceType}s`,
        });
        return;
      }

      // This ID is needed to track the file between several component layers
      const randomId = generateResourceUploadId(resourceType);

      // Parent component should handle the upload
      const resource = await onAction(ACTION.uploadResourceFile, {
        resourceType,
        file: pastedFile,
        randomId,
        index,
      });

      if (resource?.status === RESOURCE_STATUS.active) {
        switch (resourceType) {
          case RESOURCE_CONTENT_TYPE.image:
            onAction(ACTION.insertImage, {
              item: resource,
              skipConfirmation: true,
              randomId,
              index,
            });
            break;
          case RESOURCE_CONTENT_TYPE.document:
            onAction(ACTION.insertDocument, {
              item: resource,
              skipConfirmation: true,
              randomId,
              index,
            });
            break;
          default:
            break;
        }
      }
    };

    rootElement.addEventListener('paste', handler);
    return () => {
      rootElement.removeEventListener('paste', handler);
    };
  }, [shouldOpenConfirmPopup, disablePaste, onAction, rootElement, index]);
};
